import React from 'react';
import { connect } from 'react-redux';

import { RootState } from 'app/redux/state/root-state';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { CustomerDetails } from 'app/components/domain/customer-details';
import { OrderDetails } from 'app/components/domain/order-details';
import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';
import { BillingAccount } from 'app/page/orders/model/billing-account';
import { BillingDetails } from 'app/components/domain/billing-details';
import { Typography } from 'app/components/domain/typography';
import { i18n } from 'app/i18n';

import styles from './order.module.scss';

interface StateProps {
    billingAccounts: BillingAccount[];
    selectedBillingAccountId?: string;
}

type Props = StateProps;

class OrderComponent extends React.Component<Props> {
    public render(): React.ReactNode {
        const { billingAccounts, selectedBillingAccountId } = this.props;

        if (!selectedBillingAccountId) {
            throw new Error('Billing account must be selected.');
        }

        const billingAccount: BillingAccount = BillingAccountUtils.getBillingAccount(
            billingAccounts,
            selectedBillingAccountId,
        );
        const { activeOrders, selectedOrderId, customerInformation } = billingAccount;

        if (!selectedOrderId) {
            throw new Error('Order must be selected.');
        }

        const activeOrder: ActiveOrder = activeOrders[selectedOrderId];

        if (!customerInformation) {
            throw new Error('Customer information must be present.');
        }

        return (
            <div className={styles.orderContainer}>
                <CustomerDetails order={activeOrder.order} customerInformation={customerInformation} />
                <BillingDetails />
                <Typography className={styles.title} variant="subtitle1" component="h2">
                    {i18n.summary.productDetails.selectedProducts}
                </Typography>
                <OrderDetails activeOrder={activeOrder} />
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): StateProps => {
    const {
        orders: { billingAccounts, selectedBillingAccountId },
    } = state;

    return {
        billingAccounts,
        selectedBillingAccountId,
    };
};

const Order = connect(mapStateToProps)(OrderComponent);

export { Order };
